import React from 'react'
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import { BlogItem, BlogItemText, Info } from './Style';

export default function Blog(props) {
    return (
        <ScrollAnimation animateIn="animate__zoomIn">
            <BlogItem>
                <img src={props.image} />
                <Link to="/singleBlog" href="#">{props.title}</Link>
                <Info>
                    <div>
                        <i className="fas fa-calendar-alt"></i>
                        <span>20 sep 2021</span>
                    </div>
                    <div>
                        <i className="fas fa-user-edit"></i>
                        <span>Alan Jhone</span>
                    </div>
                </Info>
                <BlogItemText>
                    <p>
                        Long established fact that a
                        reader will be distract ed
                        by the readable content
                    </p>
                    <a>Read More</a>
                </BlogItemText>
            </BlogItem>
        </ScrollAnimation>
    )
}
